/*
 * @Author: Gaho
 * @Date: 2024-01-16 15:36:33
 * @LastEditors: Gaho
 * @LastEditTime: 2024-07-08 13:52:08
 */
// limbo游戏规则数据
export const limboRulesData = [
    {
        content1: 'limboRule1',
        constent2: '',
        img: null,
    }
]